<template>
  <div>
    <StoreHeader v-if="$mq !== 'mobile' && $mq !== 'tablet'" />
    <!-- new header mobile TODO COMPONENT-->
    <b-container v-else>
      <b-row style="height:80px;" class="align-items-center justify-content-center">
        <b-col cols="2" @click="menuModal=true" class="text-center">
          <font-awesome-icon style="font-size:26px;" 
            :style="{color:getCssColor('header_icon_color')}" 
            :icon="['fal', 'bars']"/>
        </b-col>
        <b-col class="text-center"><img v-if="logo" :src="logo" style="max-height:59px;max-width:140px;" /></b-col>
        <b-col cols="2" class="text-center">
          <a href="#/cart" aria-label="Cart" style="position:relative;" 
            :style="{color: getCssColor('header_icon_color')}">
            <CartBullet style="top:-12px;right:-12px"/>
            <font-awesome-icon style="font-size:26px;" 
            :style="{color:getCssColor('header_icon_color')}" :icon="['fal', 'shopping-cart']"/>
          </a>
        </b-col>
      </b-row>
      <!-- address locked -->
      <b-row @click="getAddressOrWhere()" v-if="$store.state.company.block_address_navigation && $store.state.company.block_address_navigation !== 'NO'"
        class="align-items-center" 
        :style="{backgroundColor: getCssColor('primary_bt')}" style="height:40px;">

        <b-col cols="4" style="padding-right:0px;color:#ffffff;font-weight:bold;font-size:12px;">
          Entregar em: <font-awesome-icon style="font-size:16px;color:#ffffff;" :icon="['fal', 'location']"/>
        </b-col>
        <b-col style="padding-left:0px;padding-right:0px;color:#ffffff;font-weight:300;font-size:15px;">
          <template v-if="$store.state.selectedAddressShort.length > 25">{{$store.state.selectedAddressShort.substring(0, 25)}}...</template>
          <template v-else>{{$store.state.selectedAddressShort}}</template>
           <font-awesome-icon style="float:right;margin-right:8px;font-size:20px;color:#ffffff;" :icon="['fal', 'angle-down']"/>
        </b-col>
      </b-row>
      <!-- -->
      <!-- search area -->
      <b-row class="align-items-center justify-items-center" style="height: 64px;">
        <b-col cols="12" class="text-center">
          <div style="width:295px;margin:12px auto;position:relative;">
            <input @keyup="search()" v-model="$store.state.searchTerm" type="text" 
              placeholder="Qual produto está procurando?" style="color:#333; font-size:16px;width:295px;padding-left:36px;height:35px;border: 1px solid #ECECEC;background-color:#fafafa;border-radius: 5px;" />
            <font-awesome-icon :style="{color:getCssColor('primary_bt')}" style="position:absolute;left:8px;top:8px;font-size:18px;color:#000000;" :icon="['fal', 'search']"/>
          </div>
        </b-col>
      </b-row>
      <!-- -->
      <div v-if="showFloatCart" class="shadow"  @click="gotToPath('/cart')" 
        style="background-color:#ffffff;cursor:pointer;z-index:12000;position:fixed;width:60px;height:60px;border:2px solid;border-radius:32px;bottom:20px;right:20px;text-align:center;line-height:60px;" :style="{color: getCssColor('primary_bt'), borderColor: getCssColor('primary_bt')}">
        <CartBullet style="top:2px;right:2px;"/>
        <font-awesome-icon style="font-size:28px;margin-right:3px;margin-top:17px;" :icon="['fal', 'shopping-cart']"/>
      </div>
    </b-container>
    <!-- -->

    <div class="contentHome">
      <main>
        <Banners />
        <div style="clear:both;"></div>
        <div style="width:100%">
          <IconLabels />
        </div>
        <div class="forbiden" v-if="getChoicedCompany.verify_age">
          <b-row class="justify-content-center align-items-center">
            <b-col cols="2">
              <img src="https://cdnimages.opa4.store/img/fixedimg/hand_18.png" />
            </b-col>
            <b-col cols="6" class="text-left">
              <div>Proibida a venda de álcool e cigarros para menores de 18 anos.</div>
            </b-col>
          </b-row>
        </div>
        <section @click="$router.push({path:'/offers'})" v-if="$store.state.activateOffers" style="width:calc(100% - 20px);margin-left:10px;">
          <div style="cursor:pointer;margin: 30px auto 0px auto;padding:1px 2px 1px 1px;height:150px;max-width:600px;background-color:#eee;border-radius:4px;">
            <div style="height:147px;color:#ffffff;padding:3px;width:calc(100%);border-radius:4px;position:relative;" :style="{backgroundColor:getCssColor('primary_bt')}">
              <div style="top:52px;left:-1px;position:absolute;width:20px;height:40px;border-radius:0 20px 20px 0; border-top: 1px solid #eee;border-right: 1px solid #ddd;" :style="{backgroundColor: ($mq === 'mobile' || $mq === 'tablet' ? '#F9FAFB' : '#F9FAFB')} "></div>
              <div style="top:52px;right:-2px;position:absolute;width:20px;height:40px;border-radius: 20px 0 0 20px;border-top: 1px solid #eee;border-left: 1px solid #ddd;z-index:11000;" :style="{backgroundColor: ($mq === 'mobile' || $mq === 'tablet' ? '#F9FAFB' : '#F9FAFB')} "></div>
              <b-row align-h="center" align-v="center">
                <b-col cols="7" style="color: #ffffff;padding-left:40px;font-size:18px;" v-if="this.$store.state.company.offers_information && this.$store.state.company.offers_information.callText">{{this.$store.state.company.offers_information.call_text}}<br/><span style="font-size:20px;">CLIQUE AQUI!</span></b-col>
                <b-col cols="7" style="color: #ffffff;padding-left:40px;font-size:18px;" v-else>Ative ofertas para nossas lojas físicas.<br/><span style="font-size:20px;">CLIQUE AQUI!</span></b-col>
                <b-col cols="1" style="border-right: 2px dashed #ddd;height:136px;"></b-col>
                <b-col cols="3" style="text-align:center;margin-right:10px;"><font-awesome-icon style="opacity:0.8;color:#ffffff;" :style="{fontSize: ($mq === 'mobile' || $mq === 'tablet' ? '60px' : '90px')}" :icon="['fas', 'badge-percent']"/></b-col>
              </b-row>
            </div>
          </div>
        </section>
        <PromotionsSections />
        <section>
        <template v-if="$mq === 'mobile' || $mq === 'tablet'">
          <div style="color:#2C2A29; font-size:20px;padding:20px;font-weight: 500;">
            Categorias
          </div>
          <CategoriesBox />
        </template>
        <!--div v-if="$mq === 'mobile' || $mq === 'tablet'" style="height:90px;width:100%;">
          <div @click="gotToPath('/categories/0')" style="cursor:pointer;color:#FFFFFF;font-weight:500;margin:20px auto;margin-top:30px;max-width:310px;border:0px;border-radius:4px;text-align:center;height:50px;line-height:50px;" :style="{backgroundColor: getCssColor('primary_bt')}">
            VER TODOS OS PRODUTOS
          </div>
        </div -->
        </section>
      </main>
      <Footer />
    </div>


    <!-- menu -->
    <OpaSlideModal 
      title="Menu" 
      direction="left" 
      v-model="menuModal"
      @slideModalClose="() => menuModal = false"
      >
      <div style="overflow-y:auto;overflow-x:hidden;height:calc(100vh - 56px)">

        <b-row v-if="!$store.state.user" class="text-center mt-4">
          <b-col>
            <button class="solid" @click="doEnterOrRegister()" :style="{backgroundColor:getCssColor('primary_bt')}">
              Entrar ou Cadastrar
            </button>
          </b-col>
        </b-row>


        <b-row v-else class="text-center mt-4">
          <b-col class= "text-center" @click="$router.push({path:'/profile'})" >
            <div style="margin:0px auto;margin-bottom:8px;background-color:#F1F1F1;width:118px;height:118px;border-radius:59px;" :style="{'border':'3px solid ' + getCssColor('primary_bt')}">
              <font-awesome-icon style="font-size:56px;margin-right:3px;margin-top:28px;color:#ffffff;" :icon="['far', 'user']"/>
            </div>
            <div :style="{color:getCssColor('primary_bt')}" style="font-size:18px;font-weight:500;">
              {{$store.state.user.name}} {{$store.state.user.familyName}}
              <font-awesome-icon style="font-size:22px;margin-left:8px;" :icon="['far', 'edit']"/>  
            </div>
          </b-col>
        </b-row>

        <MenuLinks class="mt-4" />
        <b-row v-if="$store.state.user" style="height:4px;" class="text-center mt-4">
          <b-col >
            <button class="solid" @click="doLogout()" :style="{backgroundColor:getCssColor('primary_bt')}">
              Sair ou entrar em outra conta
            </button>
          </b-col>
        </b-row>


      </div>
    </OpaSlideModal>

    <!-- enter or register -->
    <EnterOrRegister v-model="enterRegisterModal" @loginRegisterLogged="() => { loggedIn() }" @slideModalChange="(val) => enterRegisterModal = val"/>


      <!-- address modal -->
    <OpaSlideModal 
      v-if="this.$store.state.user && this.$store.state.user.adresses.length" 
      title="Escolher Endereço" 
      direction="down"
      v-model="addressModal"
      @slideModalClose="() => addressModal = false"
      >
      <b-row style="min-height: calc(100vh - 200px)">
        <b-col>
          <AddressList @selectedAddress="(addressId) => selectAddress(addressId)" />
        </b-col>
      </b-row>
      <b-row style="height:120px;background-color:rgb(250, 250, 250);">
        <b-col style="padding:0px;">
          <b-row style="margin-top:10px;">
            <b-col style="text-align:center;">
              <button
                :style="{color: getCssColor('primary_bt'),
                borderColor: getCssColor('primary_bt')}"
                class="wire"
                @click="newAddress()"
                  >NOVO ENDEREÇO</button>
            </b-col>
          </b-row>
          <b-row  style="margin-top:10px;">
            <b-col  style="text-align:center;">
              <button
                class="solid"
                @click="verifyBlock()"
                :style="{backgroundColor: getCssColor('primary_bt')}"
                  >CONTINUAR</button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </OpaSlideModal>


    <!-- component of consumer location -->
    <WhereAreYou v-model="whereAreYouModal" @slideModalChange="(val) => whereAreYouModal = val" @continueWithAddress="(latLong) => continueWithAddress(latLong)" />


  </div>
</template>

<script>
// @ is an alias to /src
import StoreHeader from '@/components/StoreHeader.vue'
import Footer from '@/components/Footer.vue'
import colors from '@/mixins/colors'
import IconLabels from '@/components/IconLabels.vue'
import Banners from '@/components/Banners.vue'
import CategoriesBox from '@/components/CategoriesBox.vue'
import PromotionsSections from '@/components/PromotionsSections.vue'
import navigation from '@/mixins/navigation'
import ProductsConn from '@/connection/productsv2'

import MenuLinks from '@/components/MenuLinks'
import UserConn from "@/connection/user"
import EnterOrRegister from '@/components/EnterOrRegister'
import OpaSlideModal from '@/components/OpaSlideModal'
import { EventBus } from '@/behaviours/event-bus'
import WhereAreYou from  '@/components/WhereAreYou'
import { mapGetters } from 'vuex'
import CartBullet from '@/components/CartBullet'
import LocationConn from '@/connection/location'
import AddressList from '@/components/AddressList'

export default {
  name: 'home',

  components: {
    StoreHeader,
    Footer,
    IconLabels,
    Banners,
    CategoriesBox,
    PromotionsSections,
    MenuLinks,
    EnterOrRegister,
    OpaSlideModal,
    WhereAreYou,
    CartBullet,
    AddressList
  },

  mixins: [colors, navigation],

  data () {
    return {
      whereAreYouModal: false,
      addressModal: false,
      enterRegisterModal: false,
      menuModal: false,
      showFloatCart: false,
      selectedId: null,
      initAddressModal: false
    }
  },

  async mounted () {
    console.log('COMPANY CHOICED   ->  ', this.$store.state.choicedCompanyId)
    await ProductsConn.getProductsIndex()
    EventBus.$on('srcollY', (data) => {
      if (data.newY > 80 ) {
        this.showFloatCart = true
      } else {
        this.showFloatCart = false
      }
    })
  },

  destroyed () {
    console.log('destroy header')
    EventBus.$off('srcollY')
  },

  computed: {

    ...mapGetters(['getChoiceCompanyId', 'getChoicedCompany']),

    logo () {
      if (!this.getChoicedCompany.logo) {
        return null
      } else if (!this.getChoicedCompany.logo_header) {
        return this.getChoicedCompany.logo
      } else {
        return this.getChoicedCompany.logo_header
      }
    }
  },

  methods: {
    async loggedIn () {
      console.log('LOGIN MODAL DISPATCHED')
      this.menuModal = false
      this.enterRegisterModal = false
      this.$store.state.showLoading = false
    },

    search () {
      this.$router.push({path:'/search'})
    },

    doEnterOrRegister () {
      this.enterRegisterModal = true
    },

    doLogout() {
      UserConn.logout()
      this.$store.state.choicedCompanyId = null
      this.$store.state.choicedCompany = null
      this.$store.state.selectedAddressShort = null
      if (this.$store.state.company.block_address_navigation && this.$store.state.company.block_address_navigation !== 'NO'){
        location.reload()
      }
    },

    getAddressOrWhere () {
      if (this.$store.state.user && this.$store.state.user.adresses.length) {
        this.initAddressModal = true
        this.addressModal = true
      } else {
        this.whereAreYouModal = true
      }
    },

    async continueWithAddress (latLong) {
      let result = await LocationConn.getCompaniesByLocation(latLong.lat, latLong.lng)
      if (!result.error){
        let companies = result
        if (companies.length) {
          let company = companies[companies.length-1]
          this.$store.commit('setChoicedCompanyId', company.companyId)
          this.$store.commit('setChoicedCompany', company)
        } else {
          // no companies
          this.$router.push({path: '/company_list/' + this.$store.state.lastLatLongUri})
        }
      } else {
        EventBus.$emit('showAlert', 'error', result.msg)
      }
    },

    async selectAddress(addressId) {
      console.log('SELECT ADDR HOME')
      this.selectedId = addressId
      // add the selected ID to session for use in checkout
      this.$store.state.selectedAddressId = addressId
      if (this.initAddressModal) {
        this.initAddressModal = false
        let addr = this.$store.state.user.adresses.filter(addr => addr.id === addressId)[0]
        // addr short name to selects
        this.$store.state.selectedAddressShort = addr.shortName
        //
        this.$store.state.lastLatLongUri = addr.latLong.lat + '/' + addr.latLong.lng
        this.$router.push({path: '/company_list/' + addr.latLong.lat + '/' + addr.latLong.lng})
      }
    },

    async verifyBlock () {
      this.selectAddress(this.selectedId)
    },

    newAddress () {
      this.$store.state.newAddressOrigin = "company_list"
      this.$router.push({path:'/address'})
    },


  }
}
</script>

<style lang="scss">
@import "@/css/_variables.scss";

.contentHome {
  position:relative;
  background-color:#F9FAFB;
  @media screen and (max-width: $tablet) {
  }

  @media screen and (min-width: $tablet) {
    background-color:#F9FAFB;
  }
}

.forbiden {
  width:100%;
  background-color:rgb(238, 238, 238);
  padding:16px 0;
  font-weight: 500;
  font-size: 18px;
  line-height: 13px;
  @media screen and (max-width: $tablet) {
    font-size: 13px;
  }
  img {
    width:60px; margin-right:18px;
    @media screen and (max-width: $tablet) {
      width:41px;margin-right:16px;
    }
  }
}

</style>
